import { gql } from '@provision/graphql-client';

export const CONVERSATION_SUMMARY_FIELDS = gql`
  fragment ConversationSummaryFields on ConversationSummary {
    id
    conversationSummaryId
    partnerId
    conversationId
    shortSummary
    createdAt
    updatedAt
  }
`;
